import * as React from "react";
import "./App.scss";
import {Route, Switch, withRouter} from "react-router";
import withPreAction from "../routes/withPreAction";
import connectRoute from "../routes/connectRoute";
import {SubmittedAddressPage, SuggestAddressPage} from "../routes/external";
import withPreCondition from "../routes/withPreCondition";
import {AppStore} from "../redux/AppStore";
import {getFullName} from "../redux/selectors/suggestAddressSelectors";
import {replace} from "connected-react-router";
import {reset} from "redux-form";
import '../App/App.scss'
import {paths} from "../routes/routes";

const validateFormExists = (): boolean => {
    try {
        getFullName(AppStore.getState());
        return true;
    } catch (e) {
        AppStore.dispatch(replace(paths.SUGGEST_ADDRESS));
        return false;
    }
};

const resetForm = () => {
    // reset form values
    // FIXME: make this form name a constant
    AppStore.dispatch(reset("suggestAddress"));
};

// parcel for you functions for user journey flow

/**
 * Default routes
 * IMPORTANT: Please wrap all your page in connectRoute which will add a few common functionalities such as:
 * - Stop Switch from rendering the component on deprecated stage componentWillReceiveProps
 * - Scroll window to top of the page
 *
 * @author MaxT
 * @author NickT
 */

//@ts-ignore
const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
const classNames = `grid-container-local ${isIE11?'ie11':''}`;
/**
 * Root App component
 * @constructor
 */
const App = () =>
    <main id="nzpost-js-tools" className={classNames}>
    <section className="page">
        <Switch>
            <Route exact path={paths.SUGGEST_ADDRESS} component={withPreAction(resetForm, connectRoute(SuggestAddressPage))}/>
            <Route exact path={paths.SUGGEST_ADDRESS_SUBMITTED} component={withPreCondition(validateFormExists, connectRoute(SubmittedAddressPage))}/>
        </Switch>
    </section>
</main>
;

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App/App.tsx